<!--
  --
  -- 登録内容の確認 ページ
  --
  -->
<template>
  <c-container form wide>
    <c-summary-group
      :user="user"
      @submit="onSubmit"
    >
      <!-- Title -->
      <template #title>
        登録内容の確認
      </template>

      <!-- Content -->
      <template>
        <p>
          次の内容で会員登録します。<br>
          よろしいですか？
        </p>
      </template>

      <!-- Submit button text -->
      <template #submit-text>登録</template>
    </c-summary-group>

    <!-- タイムアウト制御 -->
    <c-timeout/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CSummaryGroup from './CSummaryGroup'
import CTimeout from '../CTimeout'

import { run } from '@/libs/a'

export default {
  name: 'Comfirm',
  mixins: [
    page('登録内容の確認')
  ],
  components: {
    CSummaryGroup,
    CTimeout
  },
  computed: {
    user () {
      return {
        account: this.getters['register/account'],
        profile: this.getters['register/profile'],
        license: this.getters['register/license']
      }
    }
  },
  methods: {
    /**
     * Submit ボタンが押された
     *
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onSubmit (failed) {
      run(async () => {
        // 会員登録を行う
        const result = await this.dispatch('register/register')
        if (!result.ok) {
          // エラーがあったことを通知する
          failed(result.reason)
          return
        }

        // 次のページへ
        await this.goTo({ name: 'register/completed' })
      })
    }
  }
}
</script>
